import { staticText } from 'utils/staticText';

const money101Translation = staticText({
  brand_reward_stk_bka: {
    _: 'Moneymax Reward',
  },
  brand_reward_product_modal: {
    _: 'Moneymax Reward',
  },
  brand_reward_product_modal_cc: {
    _: 'Moneymax Reward',
  },
  apply_through: {
    _: 'Apply through Moneymax and choose from :count premium rewards',
  },
  purchase_through: {
    _: 'Purchase through SingSaver and choose from :count premium rewards',
  },
  apply_through_stk_bka: {
    _: 'Apply through Moneymax and choose from :count premium rewards (Actual Gift eligibility depends on the deposit amount provided in the terms and conditions)',
  },
  bank_gift: {
    _: `Bank Gift - On Top of Moneymax's`,
    zh: '產品禮遇',
  },
  lender_gift: {
    _: `Lender Gift - On Top of Moneymax's`,
    zh: '產品禮遇',
  },
  lightdeal: {
    _: 'Moneymax Lightning Deal',
    zh: 'Moneymax 限時優惠',
  },
  standout_tips: {
    _: 'MoneyMax Tips',
    zh: 'MoneyMax 理財建議',
  },
  standout_takeaways: {
    _: 'MoneyMax Takeaways',
    zh: 'MoneyMax 重點',
  },
  standout_perspective: {
    _: 'MoneyMax Expert Perspective',
    zh: 'MoneyMax 專家觀點',
  },
});
export default money101Translation;
